import * as ko from 'knockout';

import { ListRequestParams } from '../api/request';
import { ListLoaderDelegate, delegateActions } from '../components/list_loader';
import * as documentCategoriesApi from '../api/document_categories';
import { ListHeaderAction } from '../components/list_header';
import i18n from '../i18n';
import { translate } from '../i18n_text';
import { session } from '../session';
import { canCreateDocumentTag, canDeleteDocumentTag, reactListTablesEnabled } from '../permissions';
import { GridView } from '../utils/grid_view';
import {
  DocumentTagsListPage,
  DocumentTagsListProps,
  DocumentTagsListQuery,
  DocumentTagsListRow,
} from 'react-islands';

let template = require('raw-loader!../../templates/document_categories.html').default;

class DocumentCategoriesScreen implements ListLoaderDelegate<documentCategoriesApi.DocumentCategoryData> {
  canCreate = canCreateDocumentTag();
  canDelete = canDeleteDocumentTag();
  listActions = ko.observableArray<ListHeaderAction>([]);

  newDocumentTagsTable = reactListTablesEnabled();

  private view = new GridView('document-tags');

  tableProps = ko.pureComputed<DocumentTagsListProps>(() => ({
    view: this.view,
    fetchPage: this.fetchPage,
  }));

  constructor(params: { filters: unknown }) {
    if (this.canCreate) {
      this.listActions.push({
        title: i18n.t('Add')(),
        icon: 'add_circle',
        href: '/document_tags/new/',
        tooltipTitle: i18n.t('Add Document Tag')(),
      });
    }

    if (this.newDocumentTagsTable) {
      this.view.load(params.filters);
    }
  }

  fetch(params: ListRequestParams) {
    return documentCategoriesApi.list(params);
  }

  private fetchPage = (query: DocumentTagsListQuery): Promise<DocumentTagsListPage> =>
    this.view.fetchListPage(query, documentCategoriesApi.list, 'name_prefix', this);

  toRow = (tag: documentCategoriesApi.DocumentCategoryData): DocumentTagsListRow => ({
    id: tag.id,
    name: translate(tag.name_json),
    url: session.toTenantPath(`/document_tags/${tag.id}/`),
    actions: delegateActions(this, tag, this.view.reload),
  });

  instantiate(data: documentCategoriesApi.DocumentCategoryData) {
    return data;
  }

  remove(id: string) {
    return documentCategoriesApi.remove(id);
  }

  canRemove(data: documentCategoriesApi.DocumentCategoryData) {
    return this.canDelete;
  }
}

export let documentCategories = {
  name: 'document-categories',
  viewModel: DocumentCategoriesScreen,
  template: template,
};

ko.components.register(documentCategories.name, documentCategories);
